import { createMetricsFactory } from 'metrics-js';
const NAME = 'framework-data-schema-resolvers';
export const Metrics = createMetricsFactory(NAME, {
  library: NAME
});